import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mb-2"
};
const _hoisted_2 = {
  class: "particle-show"
};
const _hoisted_3 = {
  class: "particle-title",
  ref: "particle_title"
};
const _hoisted_4 = {
  style: {
    "color": "black"
  }
};
const _hoisted_5 = {
  class: "particle-num",
  ref: "particle_num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_beyondWarn = _resolveComponent("beyondWarn");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_beyondWarn, {
    dataList: $data.dataList
  }, null, 8, ["dataList"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('messages.use_granules')), 1)], 512), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataList, (o, j) => {
      return _openBlock(), _createBlock(_component_el_col, {
        class: "text-center",
        xs: $data.dataList.length > 3 ? 6 : 24 / $data.dataList.length,
        sm: $data.dataList.length > 4 ? 4 : 24 / $data.dataList.length,
        key: j
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          class: "particle-img",
          src: o.particelImg,
          fit: "contain"
        }, null, 8, ["src"])]),
        _: 2
      }, 1032, ["xs", "sm"]);
    }), 128))]),
    _: 1
  })], 512)])]);
}